import en from './en.json'
import fr from './fr.json'

export const fallbackLocale = 'en'

export const messages = {
  en,
  fr,
}